import { render, staticRenderFns } from "./component.vue?vue&type=template&id=2dcd8fbb&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcd8fbb')) {
      api.createRecord('2dcd8fbb', component.options)
    } else {
      api.reload('2dcd8fbb', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=2dcd8fbb&", function () {
      api.rerender('2dcd8fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/switch/src/component.vue"
export default component.exports